import React from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";

const Bar = styled.nav`
  position: sticky; bottom: 0; left: 0; right: 0; z-index: 40;
  background: rgba(255,255,255,.98); backdrop-filter: blur(8px);
  border-top: 1px solid rgba(0,0,0,.06);
  padding: 10px max(12px,env(safe-area-inset-right)) max(10px, env(safe-area-inset-bottom)) max(12px,env(safe-area-inset-left));
  display: grid; grid-template-columns: 1fr 1fr; gap: 10px;

  @media (min-width: 768px){ display:none; }
`;
const Btn = styled.button`
  background:#111827; color:white; border-radius: 12px; font-weight:800;
`;
const Ghost = styled.button`
  background:#f1f5f9; color:#0f172a; border-radius:12px; font-weight:800;
`;

export default function MobileBar(){
  const nav = useNavigate();
  const { pathname } = useLocation();

  const goBooking = () => nav("/booking");
  const goProducts = () => nav("/bounce-houses");

  // Hide on admin/login routes
  if (pathname.startsWith("/admin")) return null;

  return (
    <Bar>
      <Ghost onClick={goProducts}>Browse</Ghost>
      <Btn onClick={goBooking}>Book now</Btn>
    </Bar>
  );
}
